import { http, HttpResponse, delay } from "msw";

const users = [
    {
        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI4ZDU3MWM3OS0zNjQyLTQzZDEtOTk5YS00OWI1MDhkOTVjYTIiLCJ0ZW5hbnQiOiJOQUNITyIsImlhdCI6MTc3MDEwNTg2NSwiZXhwIjoxNzcwMTkyMjY1fQ.Isq1x5kEaIz3nsSg93zZol3vRmES5LQ-H2RSNqGxJyw",
        "user": {
            "id": "8d571c79-3642-43d1-999a-49b508d95ca2",
            "email": "admin@mail.com",
            "role": "admin"
        },
        "tenant": "NACHO",
        "permissions": [
            "catalogs.customers.create",
            "catalogs.customers.delete",
            "catalogs.customers.update",
            "catalogs.customers.view",
            "catalogs.items.create",
            "catalogs.items.delete",
            "catalogs.items.update",
            "catalogs.items.view",
            "inventory.alerts.view",
            "inventory.movements.view",
            "inventory.stock.view",
            "sales.create",
            "sales.edit",
            "sales.invoice.view",
            "sales.orders.cancel",
            "sales.orders.create",
            "sales.orders.payment",
            "sales.orders.summary",
            "sales.orders.update",
            "sales.orders.view",
            "schedule.appointments.cancel",
            "schedule.appointments.create",
            "schedule.appointments.update",
            "schedule.appointments.view",
            "users.view"
        ],
        "modules": {
            "Agenda": [
                {
                    "name": "Citas",
                    "icon": "CalendarMonth",
                    "route": "/schedule/appointments",
                    "component": "Schedule",
                    "permission": "schedule.appointments.view"
                }
            ],
            "Catálogos": [
                {
                    "name": "Clientes",
                    "icon": "People",
                    "route": "/catalogs/customers",
                    "component": "Customers",
                    "permission": "catalogs.customers.view"
                },
                {
                    "name": "Productos",
                    "icon": "Inventory2",
                    "route": "/catalogs/products",
                    "component": "Products",
                    "permission": "catalogs.products.view"
                }
            ],
            "Ventas": [
                {
                    "name": "Venta",
                    "icon": "PointOfSale",
                    "route": "/sales/service",
                    "component": "Sales",
                    "permission": "sales.service.view"
                }
            ]
        }
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}`

export const authHandlers = [
    http.post(`${baseUrl}/auth/login`, async ({ request }) => {
        const { email } = await request.json();

        const user = users.find(
            (u) => u.user.email === email
        );

        if (!user) {
            return HttpResponse.json(
                { error: "Credenciales inválidas" },
                { status: 401 }
            );
        }

        await delay(800);

        return HttpResponse.json(
            user,
            { status: 200 }
        );
    }),

    http.post(`${baseUrl}/auth/refresh`, ({ request }) => {
        return HttpResponse.json(
            {
                accessToken: "mock-new-token",
            },
            { status: 200 }
        );
    })
];
